__turbopack_context__.v({
  "block": "CancelComponent-module-scss-module__jasvEG__block",
  "buttonSimple": "CancelComponent-module-scss-module__jasvEG__buttonSimple",
  "buttonSimple1": "CancelComponent-module-scss-module__jasvEG__buttonSimple1",
  "buttongroup": "CancelComponent-module-scss-module__jasvEG__buttongroup",
  "contactUs": "CancelComponent-module-scss-module__jasvEG__contactUs",
  "goToHomepage": "CancelComponent-module-scss-module__jasvEG__goToHomepage",
  "logoIcon": "CancelComponent-module-scss-module__jasvEG__logoIcon",
  "name": "CancelComponent-module-scss-module__jasvEG__name",
  "name1": "CancelComponent-module-scss-module__jasvEG__name1",
  "paid": "CancelComponent-module-scss-module__jasvEG__paid",
  "paid1440px": "CancelComponent-module-scss-module__jasvEG__paid1440px",
  "text": "CancelComponent-module-scss-module__jasvEG__text",
});
